module.exports = __webpack_public_path__ + "static/media/01.c1978b3c.mp3";